import dayjs from 'dayjs';

import { formatDisplayNumber } from '../../../utils/format';
import { getColumnColor } from '../../../utils/helpers';

const getPlusIcon = (value) => {
  return value > 0 ? '+' : '';
};

export default function MarketNews({
  name,
  price,
  change,
  changePercent,
  date,
  source,
  variant,
}) {
  if (variant === 'withoutPrice') {
    return (
      <p className="m-0 mt-2 relative text-sm">
        {change || changePercent ? (
          <>
            <b>{name}</b>:{' '}
            <span style={{ color: getColumnColor(changePercent) }}>
              {getPlusIcon(changePercent)}
              {formatDisplayNumber(change)}({getPlusIcon(changePercent)}
              {formatDisplayNumber(changePercent.toFixed(2))}%)
            </span>{' '}
            (cập nhật lúc {date}) - Nguồn {source}
          </>
        ) : null}
      </p>
    );
  }
  return (
    <p className="m-0 mt-2 relative text-sm">
      {change || price || changePercent ? (
        <>
          <b>{name}</b>:{' '}
          <span style={{ color: getColumnColor(changePercent) }}>
            {formatDisplayNumber(price)} {getPlusIcon(changePercent)}
            {formatDisplayNumber(change)}({getPlusIcon(changePercent)}
            {formatDisplayNumber(changePercent.toFixed(2))}%)
          </span>{' '}
          (cập nhật lúc {date}) - Nguồn {source}
        </>
      ) : null}
    </p>
  );
}
